<template>
  <div>
    <div class="fixed width-100 z-99">
      <van-tabs v-model="tabIndex">
        <van-tab title="发起提交"></van-tab>
        <van-tab title="查看数据"></van-tab>
      </van-tabs>
    </div>
    <!--  站位盒子  -->
    <div class="h-98"></div>
    <!--  列表  -->
    <list v-show="tabIndex === 1" ref="list" @change="listChange"></list>
    <!--  表单  -->
    <addOrUpdate v-show="tabIndex === 0" ref="addOrUpdate"></addOrUpdate>
  </div>
</template>

<script>
import addOrUpdate from './form.vue'
import list from './list.vue'
import {mapMutations} from "vuex";

export default {
  name: 'reimbursement',
  components: {addOrUpdate, list},
  data() {
    return {
      tabIndex: 2,
      routeQuery: {},
    }
  },
  created() {
    this.routeQuery = this.$route.query
  },

  methods: {
    ...mapMutations({
      SET_PROCESS_INSTANCE_ID: 'process/SET_PROCESS_INSTANCE_ID',
      SET_TASK_ID: 'process/SET_TASK_ID',
    }),
    listChange(data) {

      const {processInstanceId, taskId, groupId} = data
      const query = {
        ...this.$route.query, processInstanceId, taskId, groupId
      }
      console.log(data, query, 22123123123)
      window.location.href = `${window.location.origin}${window.location.pathname}?processInstanceId=${processInstanceId}&taskId=${taskId}&groupId=${query.groupId}&templateId=${query.templateId}`
    }
  }
}
</script>


<style scoped lang="less">
.jisu {
  font-size: 28px;
}
</style>
